import { IState } from '../reducers'

export const getAuthIsLoggedIn = (state: IState): boolean => state.auth.isLoggedIn
export const getAuthIsLoading = ({ auth }: IState): boolean => auth.isLoading
export const getAuthErrorMsg = ({ auth }: IState): string => auth.errorMsg
